import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "./App";
import { herlaadVoorNieuweVersie } from "./lib/nieuweVersie";
import "./styles.css";

// Vite meldt zelf als een los stuk van een oudere versie niet meer te laden is.
window.addEventListener("vite:preloadError", (e) => {
  if (herlaadVoorNieuweVersie()) e.preventDefault();
});

const root = document.getElementById("root");
if (!root) throw new Error("#root ontbreekt in index.html");

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
